import React from 'react';
import * as SWMIconPack from '../Icons';
const icons = {
  Air: SWMIconPack.Air,
  Alarm: SWMIconPack.Alarm,
  ArrowCircleDown: SWMIconPack.ArrowCircleDown,
  ArrowSmallDown: SWMIconPack.ArrowSmallDown,
  ArrowDown: SWMIconPack.ArrowDown,
  ArrowCircleLeft: SWMIconPack.ArrowCircleLeft,
  ArrowSmallLeft: SWMIconPack.ArrowSmallLeft,
  ArrowLeft: SWMIconPack.ArrowLeft,
  ArrowCircleRight: SWMIconPack.ArrowCircleRight,
  ArrowSmallRight: SWMIconPack.ArrowSmallRight,
  ArrowRight: SWMIconPack.ArrowRight,
  ArrowSmallUp: SWMIconPack.ArrowSmallUp,
  ArrowUp: SWMIconPack.ArrowUp,
  ArrowCircleUp: SWMIconPack.ArrowCircleUp,
  AtEmail: SWMIconPack.AtEmail,
  Attachment: SWMIconPack.Attachment,
  Basket: SWMIconPack.Basket,
  Basketball: SWMIconPack.Basketball,
  BellDisabled: SWMIconPack.BellDisabled,
  Bell: SWMIconPack.Bell,
  Block1: SWMIconPack.Block1,
  Block2: SWMIconPack.Block2,
  Bolt: SWMIconPack.Bolt,
  BoneBroken: SWMIconPack.BoneBroken,
  Bone: SWMIconPack.Bone,
  Bookmark: SWMIconPack.Bookmark,
  CalendarCheck: SWMIconPack.CalendarCheck,
  CalendarClock: SWMIconPack.CalendarClock,
  CalendarCross: SWMIconPack.CalendarCross,
  CalendarEdit: SWMIconPack.CalendarEdit,
  CalendarLink: SWMIconPack.CalendarLink,
  CalendarLock: SWMIconPack.CalendarLock,
  CalendarMinus: SWMIconPack.CalendarMinus,
  CalendarPlus: SWMIconPack.CalendarPlus,
  CalendarUser: SWMIconPack.CalendarUser,
  CalendarWarning: SWMIconPack.CalendarWarning,
  Calendar: SWMIconPack.Calendar,
  CamDisabled: SWMIconPack.CamDisabled,
  Cam: SWMIconPack.Cam,
  CameraDisabled: SWMIconPack.CameraDisabled,
  Camera: SWMIconPack.Camera,
  Capsule: SWMIconPack.Capsule,
  Cardiology: SWMIconPack.Cardiology,
  Cart1: SWMIconPack.Cart1,
  Cart2: SWMIconPack.Cart2,
  Cart3: SWMIconPack.Cart3,
  Cart4: SWMIconPack.Cart4,
  Cast: SWMIconPack.Cast,
  ChartVertical: SWMIconPack.ChartVertical,
  Chart: SWMIconPack.Chart,
  CheckCircle: SWMIconPack.CheckCircle,
  CheckSmall: SWMIconPack.CheckSmall,
  Check: SWMIconPack.Check,
  ChevronCircleDown: SWMIconPack.ChevronCircleDown,
  ChevronSmallDown: SWMIconPack.ChevronSmallDown,
  ChevronDown: SWMIconPack.ChevronDown,
  ChevronCircleLeft: SWMIconPack.ChevronCircleLeft,
  ChevronSmallLeft: SWMIconPack.ChevronSmallLeft,
  ChevronLeft: SWMIconPack.ChevronLeft,
  ChevronCircleRight: SWMIconPack.ChevronCircleRight,
  ChevronSmallRight: SWMIconPack.ChevronSmallRight,
  ChevronRight: SWMIconPack.ChevronRight,
  ChevronCircleUp: SWMIconPack.ChevronCircleUp,
  ChevronSmallUp: SWMIconPack.ChevronSmallUp,
  ChevronUp: SWMIconPack.ChevronUp,
  Circle: SWMIconPack.Circle,
  Clock: SWMIconPack.Clock,
  Cloud: SWMIconPack.Cloud,
  Coin: SWMIconPack.Coin,
  Command: SWMIconPack.Command,
  Copy: SWMIconPack.Copy,
  Creditcard: SWMIconPack.Creditcard,
  CrossCircle: SWMIconPack.CrossCircle,
  CrossSmall: SWMIconPack.CrossSmall,
  Cross: SWMIconPack.Cross,
  Crown1: SWMIconPack.Crown1,
  Crown2: SWMIconPack.Crown2,
  Cut: SWMIconPack.Cut,
  Delete: SWMIconPack.Delete,
  Dislike: SWMIconPack.Dislike,
  Dna: SWMIconPack.Dna,
  DocumentCheck: SWMIconPack.DocumentCheck,
  DocumentClean: SWMIconPack.DocumentClean,
  DocumentCross: SWMIconPack.DocumentCross,
  DocumentFilled: SWMIconPack.DocumentFilled,
  DocumentMinus: SWMIconPack.DocumentMinus,
  DocumentPlus: SWMIconPack.DocumentPlus,
  Download: SWMIconPack.Download,
  Edit1: SWMIconPack.Edit1,
  Edit2: SWMIconPack.Edit2,
  Edit3: SWMIconPack.Edit3,
  Edit4: SWMIconPack.Edit4,
  EmoteNormal: SWMIconPack.EmoteNormal,
  EmoteSad: SWMIconPack.EmoteSad,
  EmoteSmile: SWMIconPack.EmoteSmile,
  Explore: SWMIconPack.Explore,
  EyeClosed: SWMIconPack.EyeClosed,
  EyeOpen: SWMIconPack.EyeOpen,
  Faceid: SWMIconPack.Faceid,
  Female: SWMIconPack.Female,
  Filters1: SWMIconPack.Filters1,
  Filters2: SWMIconPack.Filters2,
  Filters3: SWMIconPack.Filters3,
  Flag1: SWMIconPack.Flag1,
  Flag2: SWMIconPack.Flag2,
  Flag3: SWMIconPack.Flag3,
  Forward: SWMIconPack.Forward,
  Fullscreen: SWMIconPack.Fullscreen,
  Gift: SWMIconPack.Gift,
  Globe1: SWMIconPack.Globe1,
  Grid2Horizontal: SWMIconPack.Grid2Horizontal,
  Grid2Vertical: SWMIconPack.Grid2Vertical,
  Grid4: SWMIconPack.Grid4,
  Headphones: SWMIconPack.Headphones,
  Heart: SWMIconPack.Heart,
  Home1: SWMIconPack.Home1,
  Home2: SWMIconPack.Home2,
  HomeHospital: SWMIconPack.HomeHospital,
  Horizontal: SWMIconPack.Horizontal,
  Hourglass: SWMIconPack.Hourglass,
  Ice: SWMIconPack.Ice,
  Image1: SWMIconPack.Image1,
  Inbox: SWMIconPack.Inbox,
  InfoCircle: SWMIconPack.InfoCircle,
  InfoSmall: SWMIconPack.InfoSmall,
  Info: SWMIconPack.Info,
  Key: SWMIconPack.Key,
  Laptop: SWMIconPack.Laptop,
  Like: SWMIconPack.Like,
  Link: SWMIconPack.Link,
  ListCenter: SWMIconPack.ListCenter,
  ListLeft: SWMIconPack.ListLeft,
  ListPointers: SWMIconPack.ListPointers,
  ListRight: SWMIconPack.ListRight,
  Location1: SWMIconPack.Location1,
  Location2: SWMIconPack.Location2,
  LocationMed1: SWMIconPack.LocationMed1,
  LocationMed2: SWMIconPack.LocationMed2,
  LockOff: SWMIconPack.LockOff,
  LockOn: SWMIconPack.LockOn,
  Login: SWMIconPack.Login,
  Logout: SWMIconPack.Logout,
  Mail: SWMIconPack.Mail,
  Male: SWMIconPack.Male,
  Map: SWMIconPack.Map,
  Medkit: SWMIconPack.Medkit,
  Meds: SWMIconPack.Meds,
  MenuHamburger: SWMIconPack.MenuHamburger,
  MenuHorizontal: SWMIconPack.MenuHorizontal,
  MenuVertical: SWMIconPack.MenuVertical,
  MessageCircleDots: SWMIconPack.MessageCircleDots,
  MessageCircleLines: SWMIconPack.MessageCircleLines,
  MessageCircle: SWMIconPack.MessageCircle,
  MessageSquareDots: SWMIconPack.MessageSquareDots,
  MessageSquareLines: SWMIconPack.MessageSquareLines,
  MessageSquare: SWMIconPack.MessageSquare,
  MicrophoneDisabled: SWMIconPack.MicrophoneDisabled,
  Microphone: SWMIconPack.Microphone,
  MinusCircle: SWMIconPack.MinusCircle,
  MinusSmall: SWMIconPack.MinusSmall,
  Minus: SWMIconPack.Minus,
  Money: SWMIconPack.Money,
  Moon: SWMIconPack.Moon,
  Music: SWMIconPack.Music,
  Navigation: SWMIconPack.Navigation,
  Newscreen: SWMIconPack.Newscreen,
  Next: SWMIconPack.Next,
  Offer: SWMIconPack.Offer,
  Package: SWMIconPack.Package,
  Pause: SWMIconPack.Pause,
  PhoneCall: SWMIconPack.PhoneCall,
  PhoneCross: SWMIconPack.PhoneCross,
  PhoneDown: SWMIconPack.PhoneDown,
  Phone: SWMIconPack.Phone,
  Pin1: SWMIconPack.Pin1,
  Pin2: SWMIconPack.Pin2,
  PinpaperCheck: SWMIconPack.PinpaperCheck,
  PinpaperCross: SWMIconPack.PinpaperCross,
  PinpaperFilled: SWMIconPack.PinpaperFilled,
  PinpaperMinus: SWMIconPack.PinpaperMinus,
  PinpaperPlus: SWMIconPack.PinpaperPlus,
  Play: SWMIconPack.Play,
  PlusCircle: SWMIconPack.PlusCircle,
  PlusSmall: SWMIconPack.PlusSmall,
  Plus: SWMIconPack.Plus,
  Power: SWMIconPack.Power,
  Previous: SWMIconPack.Previous,
  Print: SWMIconPack.Print,
  QuestionCircle: SWMIconPack.QuestionCircle,
  QuestionSmall: SWMIconPack.QuestionSmall,
  Question: SWMIconPack.Question,
  Quote: SWMIconPack.Quote,
  RedoCircle: SWMIconPack.RedoCircle,
  RedoSmall: SWMIconPack.RedoSmall,
  Redo: SWMIconPack.Redo,
  RefreshCircle: SWMIconPack.RefreshCircle,
  RefreshSmall: SWMIconPack.RefreshSmall,
  Refresh: SWMIconPack.Refresh,
  ResizeCircleHorizontal: SWMIconPack.ResizeCircleHorizontal,
  ResizeSmallHorizontal: SWMIconPack.ResizeSmallHorizontal,
  ResizeCircleVertical: SWMIconPack.ResizeCircleVertical,
  ResizeSmallVertical: SWMIconPack.ResizeSmallVertical,
  Rewind: SWMIconPack.Rewind,
  RotateCircleLeft: SWMIconPack.RotateCircleLeft,
  RotateSmallLeft: SWMIconPack.RotateSmallLeft,
  RotateLeft: SWMIconPack.RotateLeft,
  RotateCircleRight: SWMIconPack.RotateCircleRight,
  RotateSmallRight: SWMIconPack.RotateSmallRight,
  RotateRight: SWMIconPack.RotateRight,
  Save: SWMIconPack.Save,
  ScreenDisabled: SWMIconPack.ScreenDisabled,
  ScreenShare: SWMIconPack.ScreenShare,
  Screen: SWMIconPack.Screen,
  Search: SWMIconPack.Search,
  Send1: SWMIconPack.Send1,
  Send2: SWMIconPack.Send2,
  Settings: SWMIconPack.Settings,
  Share1: SWMIconPack.Share1,
  Share2: SWMIconPack.Share2,
  ShieldCheck: SWMIconPack.ShieldCheck,
  ShieldCross: SWMIconPack.ShieldCross,
  ShieldEmpty: SWMIconPack.ShieldEmpty,
  Shirt: SWMIconPack.Shirt,
  Smartphone: SWMIconPack.Smartphone,
  Sound0: SWMIconPack.Sound0,
  Sound1: SWMIconPack.Sound1,
  Sound2: SWMIconPack.Sound2,
  Speaker0: SWMIconPack.Speaker0,
  Speaker1: SWMIconPack.Speaker1,
  Speaker2: SWMIconPack.Speaker2,
  SpeakerCross: SWMIconPack.SpeakerCross,
  SpeakerDisabled: SWMIconPack.SpeakerDisabled,
  Star1: SWMIconPack.Star1,
  Star2: SWMIconPack.Star2,
  Stop: SWMIconPack.Stop,
  Stopwatch: SWMIconPack.Stopwatch,
  Suitcase: SWMIconPack.Suitcase,
  Sun: SWMIconPack.Sun,
  Syringe: SWMIconPack.Syringe,
  Tag: SWMIconPack.Tag,
  TestTube: SWMIconPack.TestTube,
  Tooth: SWMIconPack.Tooth,
  Trash1: SWMIconPack.Trash1,
  Trash2: SWMIconPack.Trash2,
  TrendingDown: SWMIconPack.TrendingDown,
  TrendingUp: SWMIconPack.TrendingUp,
  Trophy: SWMIconPack.Trophy,
  Umbrella1: SWMIconPack.Umbrella1,
  Umbrella2: SWMIconPack.Umbrella2,
  UndoCircle: SWMIconPack.UndoCircle,
  UndoSmall: SWMIconPack.UndoSmall,
  Undo: SWMIconPack.Undo,
  Upload: SWMIconPack.Upload,
  User1: SWMIconPack.User1,
  User2: SWMIconPack.User2,
  UserCheck: SWMIconPack.UserCheck,
  UserCross: SWMIconPack.UserCross,
  UserInfo: SWMIconPack.UserInfo,
  UserMinus: SWMIconPack.UserMinus,
  UserPlus: SWMIconPack.UserPlus,
  UserQuestion: SWMIconPack.UserQuestion,
  UserWarning: SWMIconPack.UserWarning,
  UsersMore: SWMIconPack.UsersMore,
  Users: SWMIconPack.Users,
  Vertical: SWMIconPack.Vertical,
  Virus: SWMIconPack.Virus,
  Wallet: SWMIconPack.Wallet,
  Wand: SWMIconPack.Wand,
  WarningCircle: SWMIconPack.WarningCircle,
  WarningSmall: SWMIconPack.WarningSmall,
  Warning: SWMIconPack.Warning,
  Waterdrop: SWMIconPack.Waterdrop,
  Windows: SWMIconPack.Windows,
  ZoomIn: SWMIconPack.ZoomIn,
  ZoomOut: SWMIconPack.ZoomOut
};

const SWMIcon = ({
  name,
  color,
  strokeWidth,
  size,
  set
}) => {
  const Icon = icons[name];
  if (!Icon) throw new Error(`Icon '${name}' doesn't exists`);
  return /*#__PURE__*/React.createElement(Icon, {
    color: color,
    strokeWidth: strokeWidth,
    size: size,
    set: set
  });
};

export default SWMIcon;